import React from 'react';
import * as Icon from './whizzIcons';
import type { HTMLAttributes } from 'react';
import type { IconProps } from './types';
import type { WhizzIconType } from '../../util/types';
import IconWrapper from './common/IconWrapper';
import { ICON_WHIZZ } from '../../util/data-id';

type Ref = HTMLDivElement;
type HTMLProps = Omit<HTMLAttributes<Ref>, 'color'>;
interface Props extends Omit<IconProps, 'color'>, HTMLProps {
  /**
   * Sets Whizz icon by identification name.
   */
  icon: WhizzIconType;
}

const WhizzIcon = React.forwardRef<Ref, Props>(({ icon, size, ...other }: Props, ref): JSX.Element => {
  return (
    <IconWrapper ref={ref} data-id={ICON_WHIZZ} size={size} color={null} {...(other as HTMLProps)}>
      {/*TODO Fix this - Unable to validate computed reference to imported namespace 'Icon'  import/namespace*/}
      {/*eslint import/namespace: ['error', { allowComputed: true }]*/}
      <img src={Icon[icon]} alt={icon} />
    </IconWrapper>
  );
});

WhizzIcon.displayName = 'WhizzIcon';

export default WhizzIcon;
